import React, { useEffect, useState } from 'react'
import AOS from "aos";
import Features from '../HomeMain/Features/Main'
import AboutApp from '../HomeMain/AboutApp/Main'
import Design from '../HomeMain/Design/Main'
import Sliderone from '../Menhome/Sliderone';
import mascot from '../../assets/images/mascot.png'

const Main = ({ setfooter, setnavbar, setbrdcum }) => {
  const [hasEnteredContent, setHasEnteredContent] = useState(false)
  const [guide, setGuide] = useState({ visible: false, section: 1, x: 0, y: 0, size: 220 })
  const [hasReachedFooter, setHasReachedFooter] = useState(false)
  const [hasReachedFeatures, setHasReachedFeatures] = useState(false)

  useEffect(() => {
    AOS.init({ once: true });
    AOS.refresh();
  }, []);

  useEffect(() => {
    let animationFrame = null

    const updateLandingScene = () => {
      const about = document.querySelector('.about_app_section')
      const design = document.querySelector('.modern_ui_section')

      if (about && design) {
        const aboutBounds = about.getBoundingClientRect()
        const designBounds = design.getBoundingClientRect()
        const aboutPhones = document.querySelector('.about_phone_pair')
        const designPhones = document.querySelector('.modern_phone_stage')
        const section = designBounds.top <= window.innerHeight * .55 ? 2 : 1
        const target = section === 1 ? aboutPhones : designPhones
        const targetBounds = target && target.getBoundingClientRect()
        const size = window.innerWidth < 768 ? 136 : Math.min(290, Math.max(230, window.innerWidth * .17))
        const inGuideZone = aboutBounds.top < window.innerHeight * .88 && designBounds.bottom > window.innerHeight * .12
        let x = 0
        let y = 0

        if (targetBounds) {
          if (section === 1) {
            x = targetBounds.right - size * .42
            y = targetBounds.top + targetBounds.height * .42
          } else {
            x = targetBounds.left - size * .48
            y = targetBounds.top + targetBounds.height * .48
          }
          x = Math.min(window.innerWidth - size - 4, Math.max(4, x))
          y = Math.min(window.innerHeight - size - 4, Math.max(74, y))
        }

        setGuide({
          visible: Boolean(inGuideZone && targetBounds),
          section,
          x,
          y,
          size
        })
      }

      const footer = document.querySelector('.nexa-newsletter')
      setHasReachedFooter(Boolean(footer && footer.getBoundingClientRect().top <= window.innerHeight * .88))

      const features = document.querySelector('#features')
      setHasReachedFeatures(Boolean(features && features.getBoundingClientRect().top <= window.innerHeight * .76))

      setHasEnteredContent(previous => {
        if (window.scrollY > 240) return true
        if (window.scrollY < 40) return false
        return previous
      })
    }

    const requestSceneUpdate = () => {
      if (animationFrame !== null) return
      animationFrame = window.requestAnimationFrame(() => {
        animationFrame = null
        updateLandingScene()
      })
    }

    updateLandingScene()
    window.addEventListener('scroll', requestSceneUpdate, { passive: true })
    window.addEventListener('resize', requestSceneUpdate)
    return () => {
      window.removeEventListener('scroll', requestSceneUpdate)
      window.removeEventListener('resize', requestSceneUpdate)
      if (animationFrame !== null) window.cancelAnimationFrame(animationFrame)
    }
  }, [])

  useEffect(() => {
    setfooter({ f1: true })
    setnavbar({ n2: false })
    setbrdcum({ b1: true })
    localStorage.setItem("navbar", "home")
  }, [setfooter, setnavbar, setbrdcum])

  return (
    <main className={`landing_page ${hasEnteredContent ? 'is-exploring' : ''} ${hasReachedFeatures ? 'features-in-view' : ''}`}>
      <div className="landing_background landing_background_with_mascot" aria-hidden="true"></div>
      <div className="landing_background landing_background_without_mascot" aria-hidden="true"></div>
      <Sliderone />
      <AboutApp />
      <Design />
      <Features />
      <aside
        className={`mascot_scroll_guide two-section-guide guide-section-${guide.section} ${guide.visible ? 'is-guiding' : ''} ${hasReachedFeatures ? 'is-handing-off' : ''} ${hasReachedFooter ? 'is-at-footer' : ''}`}
        style={{
          '--guide-x': `${guide.x}px`,
          '--guide-y': `${guide.y}px`,
          '--guide-size': `${guide.size}px`
        }}
        aria-label={`Nexa mascot guiding the ${guide.section === 1 ? 'Meet Nexa' : 'Protection'} section`}
      >
        <img src={mascot} alt="Nexa mascot guide" />
      </aside>
    </main>
  )
}

export default Main
